<template>
  <article class="container">
    <section class="content mycheck_wrap">
      <div class="content_inner">
        <h1 class="logo_mc">
          <img src="~@/assets/images/common/logo_mc.png" alt="multicampus">
        </h1>
        <div class="section_header mycheck_header">
          <p class="text attendance_msg"><strong>{{ atdncInfo.mbrFnm }}</strong>님, <br><strong>{{ atdncInfo.lrnDseq }}일차 출석</strong>확인이 완료되었습니다.</p>
          <!-- Random message -->
          <RandomMessage
            :check-in="atdncType ==='enter' ? true : false"
            :show-rnd-msg="showRndMsg"
            :show-animation="showAnimation"
            :show-emoji="showEmoji"
          />
          <!-- // Random message -->
        </div>
        <div class="section_content" data-effect-slide="scroll">
          <div class="sub_title_wrap center">
            <div class="chip_wrap"><span class="chips">{{ atdncInfo.lrnDseq }}일차</span></div>
            <h2 class="sub_title">{{ atdncInfo.corsNm }}</h2>
          </div>
          <div class="info_box-wrap" data-effect-slide="scroll">
            <div class="box_wrap">
              <p class="text check-in"><span class="btn_text" >입실시간</span></p>
              <p class="time_tx">{{ atdncInfo.fstAtdncChkDtm }}</p>
            </div>
            <div class="box_wrap">
              <p class="text check-out"><span class="btn_text" >퇴실시간</span></p>
              <p class="time_tx">{{ atdncInfo.lastAtdncChkDtm || '-' }}</p>
            </div>
            <div class="box_wrap wide blue">
              <p class="text check-on"><span class="btn_text" >출석인정시간</span></p>
              <p class="time_tx">{{ atdncInfo.atdncRecordTime || '-' }}</p>
            </div>
          </div>
          <p class="text_gray ico_notice">'출석 인정 시간'은 강의 일정표에 등록된 교육시간을 기준으로 적용됩니다.</p>
        </div>
      </div>
    </section>

  </article>
</template>

<script>
// import commonMixin from '@/mixin/commonMixin'
// import globalMixin from '@/mixin/globalMixin'
import MotionEffects from '@/assets/js/MotionEffects'
import RandomMessage from '@/components/pages/nrw/attend/RandomMessage' // 랜덤 메세지 컴포넌트

export default {
  name: 'AttendJoin',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: QR출석체크 인증 후'
    }
  },
  components: {RandomMessage},
  mixins: [MotionEffects],
  props: {
  },
  data () {
    return {
      atdncInfo: {},
      corsInfo: {},
      greetingMsg: '',
      atdncType: this.$route.query.atdncType,
      showRndMsg: true, // 랜덤 메세지 영역 노출 여부
      showAnimation: true, // 랜덤 메세지 영역 애니메이션 적용 여부
      showEmoji: true // 문장 끝에 이모지 사용 여부
      // checkIn: true, // 입실, 퇴실 구분(true: 입실)

    }
  },
  created () {
    this.selectAtdncInfo()
    // this.atdncInfo = this.$route.params.atdncItems
    // this.selectGreetingMessage()
  },
  beforeDestroy () {
    sessionStorage.removeItem('corsInfo')
  },
  mounted () {
    const headerTxt = document.querySelector('.mycheck_header .text.attendance_msg') // 입, 퇴실 메세지 영역
    if (headerTxt) headerTxt.classList.add('in') // 입, 퇴실 메세지 영역 노출
  },
  methods: {
    selectAtdncInfo () {
      if (this.$route.params.atdncItems) {
        this.atdncInfo = this.$route.params.atdncItems
        this.corsInfo = this.$route.params.corsInfo
        sessionStorage.setItem('corsInfo', JSON.stringify(this.corsInfo))
        return
      }

      const corsInfoStorage = JSON.parse(sessionStorage.getItem('corsInfo'))
      const params = {...corsInfoStorage}
      this.$http.b2c.selectAtdncInfo(this, params).then( result => {
        if (result.data.status === 'OK') {
          this.atdncInfo = result.data.data.atdncInfo
        }
      })
    }
  }
}
</script>

<style scoped>
.container {padding-top:0;}
.mycheck_header {position:relative;height:66px;}
.mycheck_header .text {opacity:0;position:absolute;top:50%;left:0;height:66px;transition:top 0.54s cubic-bezier(0, 0.55, 0.45, 1), opacity 0.2s ease-in;}
.mycheck_header .text.in {opacity:1;top:0;}
.mycheck_header .text.out {opacity:0;top:-50%;}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/attend/AttendJoin.vue